// NPM Imports
import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Loader, Button } from "@revvsales/components";

// Components Imports
import { EmptyScreen } from "../../../commonComponents";
import withRbac from "../../../app/withRbac";
import TitleBar from "../../TitleBar";
import AddWorkFlow from "../AddWorkFlow";

// Actions Imports
import { WorkFlowActions } from "../../../actions";

// Internals Imports
import { PERMISSIONS, LOADING_MSG } from "../../../constants";
import { GlobalUtils } from "../../../utils";
import WF_EMPTY_SCREEN_IMG_SRC from "../../../assets/workflow-empty.png";

// Destructuring
const { getAllWorkFlows } = WorkFlowActions;
const { checkUserPermission } = GlobalUtils;

class WorkFlowList extends Component {
  state = {
    showLoader: false,
    showPopUp: false,
  };

  componentDidMount() {
    this._onInit();
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _onInit = () => {
    this._toggleLoader(true);
    this.props.getAllWorkFlows().then(() => {
      this._toggleLoader(false);
    });
  };

  _togglePopUp = () => {
    this.setState(prevState => ({ showPopUp: !prevState.showPopUp }));
  };

  _decideWFListView = (workflowItem, hasUpdatePermission) => {
    const { id, name, entity, description } = workflowItem;
    if (hasUpdatePermission) {
      return (
        <Link to={`workflow/${id}`} key={id}>
          <div className="workflowlist-item">
            <span className="col-md-3 is-name">
              <span className="workflowlist-item-iconwrapper">
                <i className="workflowlist-item-icon">
                  <FontAwesomeIcon icon={["fad", "network-wired"]} />
                </i>
              </span>
              <span className="workflowlist-item-wftitle">{name}</span>
            </span>
            <span className="col-md-4 is-description">{description}</span>
            <span className="col-md-3">
              <span className="workflow-type-tag">
                {entity} approval workflow
              </span>
            </span>
            {/* AV_TO_DO :: use this section when API is available
                for changing the status of wf */}
            {/* <span className="col-md-2 is-last">
              <Input
                checked={active}
                className="workflowlist-switch"
                id={`workflow-${id}`}
                isSwitch
                readOnly
                type="checkbox"
                value=""
              />
            </span> */}
          </div>
        </Link>
      );
    }
    return (
      <div className="workflowlist-item" key={id}>
        <span className="col-md-3 is-name">
          <i className="workflowlist-item-icon">
            <FontAwesomeIcon icon={["far", "network-wired"]} />
          </i>
          {name}
        </span>
        <span className="col-md-4 is-description">{description}</span>
        <span className="col-md-3">
          <span className="workflow-type-tag">{entity} approval workflow</span>
        </span>
        {/* AV_TO_DO :: use this section when API is available
            for changing the status of wf */}
        {/* <span className="col-md-2 is-last">
          <Input
            checked={active}
            className="workflowlist-switch"
            id={`workflow-${id}`}
            isSwitch
            readOnly
            disabled
            type="checkbox"
            value=""
          />
        </span> */}
      </div>
    );
  };

  // if there are workflows then,
  // list else show the empty screen image
  _workflowList = workflowList => {
    if (workflowList.length > 0) {
      return workflowList.map(item =>
        this._decideWFListView(
          item,
          checkUserPermission(PERMISSIONS.WORKFLOWS.UPDATE_WORKFLOWS),
        ),
      );
    }
    return (
      <EmptyScreen
        imageSrc={WF_EMPTY_SCREEN_IMG_SRC}
        message={`Looks like you don't have any workflows, create a new workflow!`}
      />
    );
  };

  render() {
    const { workflowList } = this.props;
    if (this.state.showLoader) {
      return <Loader label={LOADING_MSG.WORKFLOWS} />;
    }

    const CreateWorkflowBtn = withRbac(() => (
      <Button
        className="workflowlist-add"
        onClick={this._togglePopUp}
        data-test="workflowlist-create-btn">
        Create workflow
      </Button>
    ));

    // Return the below component when loader is hidden
    return (
      <Fragment>
        <div className="workflowlist-topbar page-topbar">
          <TitleBar
            iconName="network-wired"
            title="Workflows"
            subTitle="This is the place to manage all your workflows and automations"
          />
          <div className="create-container">
            <CreateWorkflowBtn
              permission={PERMISSIONS.WORKFLOWS.CREATE_WORKFLOWS}
            />
          </div>
        </div>
        <div className="workflowlist-wrapper">
          <div className="workflowlist-scrollable">
            {workflowList.length > 0 ? (
              <div className="workflowlist-title-wrapper">
                <div className="workflowlist-title">
                  <span className="col-md-3">Workflows</span>
                  <span className="col-md-4">Description</span>
                  <span className="col-md-3">Workflow type</span>
                  {/* AV_TO_DO :: use this section when API is available
                    for changing the status of wf */}
                  {/* <span className="col-md-2 is-last">STATUS</span> */}
                </div>
              </div>
            ) : null}
            <div className="workflowlist-details">
              {this._workflowList(workflowList)}
            </div>
          </div>
        </div>
        <Modal
          open={this.state.showPopUp}
          onClose={this._togglePopUp}
          closeOnOverlayClick={false}
          center>
          <AddWorkFlow onCancel={this._togglePopUp} />
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { workflowList } = state.WorkFlowStore;
  return {
    workflowList,
  };
};

const mapDispatchToProps = {
  getAllWorkFlows,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WorkFlowList);



// WEBPACK FOOTER //
// ./src/components/WorkFlow/WorkFlowList/WorkFlowList.js